/**
 * Helper to add simple jquery methods based on classes
 *
 * @param class_name
 * @param jquery_method_name
 */
function sw_jquery_widget_add ( class_name, jquery_method_name ) {
  jQuery.fn[jquery_method_name] = function (method, ...args) {
    if ( typeof method === 'undefined') {
      this.once(jquery_method_name).each(function () {
        const o = new class_name($(this));
      });
    } else if ( method === 'getObject' ) {
      return this.eq(0).data(jquery_method_name);
    } else {
      this.each(function () {
        const c = $(this)[jquery_method_name]('getObject');
        if (c && typeof c[method] === 'function') {
          c[method](...args);
        }
      });
    }
  };
}

